<template>
  <div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="poste"
                        >Poste <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="postes"
                        :reduce="(poste) => poste.uuid"
                        v-model="form.poste"
                        placeholder="Poste"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="poste"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('poste'),
                          }"
                        />
                        <has-error :form="form" field="poste"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="poste"
                        >Nature du poste
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="naturePostes"
                        :reduce="(naturePoste) => naturePoste.uuid"
                        v-model="form.nature_poste"
                        placeholder="Nature du poste"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="poste"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('nature_poste'),
                          }"
                        />
                        <has-error
                          :form="form"
                          field="nature_poste"
                        ></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="poste"
                        >Type de contrat
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="contratTypes"
                        :reduce="(contratType) => contratType.uuid"
                        v-model="form.contrat_type"
                        placeholder="Type de contrat"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="poste"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('contrat_type'),
                          }"
                        />
                        <has-error
                          :form="form"
                          field="contrat_type"
                        ></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="nbre_poste"
                        >Nombre de poste
                        <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <div
                          class="input-group-prepend bg-transparent"
                          @click="
                            form.nbre_poste =
                              form.nbre_poste - 1 > 0 ? form.nbre_poste - 1 : 1
                          "
                        >
                          <span
                            class="input-group-text bg-transprent border-right-0"
                            role="button"
                          >
                            <i class="fas fa-minus text-danger"></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control text-center"
                          :class="{
                            'is-invalid': form.errors.has('nbre_poste'),
                          }"
                          id="nbre_poste"
                          v-model.number="form.nbre_poste"
                          placeholder="Nombre de poste"
                          required
                        />
                        <div
                          class="input-group-append bg-transparent"
                          @click="form.nbre_poste++"
                        >
                          <span
                            class="input-group-text bg-transprent border-left-0"
                            role="button"
                          >
                            <i class="fas fa-plus text-success"></i>
                          </span>
                        </div>
                        <has-error :form="form" field="nbre_poste"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2 mt-n2 mt-md-0">
                    <div class="form-group">
                      <label for="date_debut"
                        >Date début <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_debut"
                        name="date_debut"
                        placeholder="Date début"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_debut'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_debut"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2 mt-n2 mt-md-0">
                    <div class="form-group">
                      <label for="date_fin"
                        >Date fin <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_fin"
                        name="date_fin"
                        placeholder="Date fin"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_fin'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_fin"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <div class="form-group">
                      <label for="diplome_formation"
                        >Formations / diplômes (max : 150 caractères )
                        <span class="text-danger">*</span>
                      </label>
                      <textarea
                        v-model="form.diplome_formation"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('diplome_formation'),
                        }"
                        rows="5"
                        maxlength="150"
                      ></textarea>
                      <has-error
                        :form="form"
                        field="diplome_formation"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <div class="form-group">
                      <label for="experience"
                        >Expériences (max : 150 caractères )
                        <span class="text-danger">*</span></label
                      >
                      <textarea
                        v-model="form.experience"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('experience'),
                        }"
                        rows="5"
                        maxlength="150"
                      ></textarea>
                      <has-error :form="form" field="experience"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-alert
          :show="form.errors.has('fonction_mission')"
          dismissible
          variant="danger"
          class="mt-1"
        >
          <span v-html="form.errors.get('fonction_mission')"></span>
        </b-alert>

        <div class="row">
          <div class="col-md-12">
            <b-card
              class="text-black"
              header-class="bg-silver border-bottom-0"
              no-body
            >
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="mdi mdi-comment-edit mr-0"></i> Fonctions /
                    missions
                  </h5>
                </div>
              </template>
              <div class="row editor">
                <div class="col-md-12">
                  <vue-editor
                    id="fonction-mission"
                    placeholder="Fonctions / missions"
                    v-model="form.fonction_mission"
                    :editorToolbar="VueEditorToolbar"
                    class="fonction-mission"
                  />
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/offre-emploi';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
import { VueEditor } from 'vue2-editor';
import VueEditorToolbar from '@/vue-editor-tool-bar';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      form: new Form({
        date_debut: '',
        date_fin: '',
        nbre_poste: 1,
        diplome_formation: '',
        experience: '',
        fonction_mission: '',
        poste: '',
        nature_poste: '',
        contrat_type: '',
      }),
      VueEditorToolbar,
    };
  },
  computed: {
    ...mapGetters('offreEmploi', [
      'currentOffre',
      'postes',
      'naturePostes',
      'contratTypes',
    ]),
  },
  components: {
    DatePicker,
    VueEditor,
  },
  methods: {
    ...mapActions('offreEmploi', [
      'setCurrentOffre',
      'setPostes',
      'setNaturePostes',
      'setContratTypes',
    ]),
    async refresh() {
      this.setPostes([]);
      this.setNaturePostes([]);
      this.setContratTypes([]);
      this.setCurrentOffre(null);

      await window.axios
        .all([
          window.axios.get(URL.GET_REQUIREMENTS),
          window.axios.get(URL.OFFRE_EMPLOI + '/' + this.$route.params.id, {
            params: {
              edit: true,
            },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.setCurrentOffre(resp2.data.offre_emploi);
            this.setPostes(resp1.data.postes);
            this.setNaturePostes(resp1.data.nature_postes);
            this.setContratTypes(resp1.data.contrat_types);
          })
        )
        .catch();

      await this.init();
    },
    init() {
      Object.assign(this.form, this.currentOffre);
    },
    submit() {
      this.form
        .put(URL.OFFRE_EMPLOI + '/' + this.$route.params.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.refresh();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
